import { useCockpit } from "../../lib/state";
import TaskDetailDrawer from "./TaskDetailDrawer";
import ApprovalDetailDrawer from "./ApprovalDetailDrawer";
import ServiceDetailDrawer from "./ServiceDetailDrawer";
import NoteDetailDrawer from "./NoteDetailDrawer";

export default function RightDrawer() {
  const { kind, id } = useCockpit((s) => s.drawer);
  const closeDrawer = useCockpit((s) => s.closeDrawer);
  const open = kind !== null && id !== null;
  if (!open) return null;

  let body: React.ReactNode = null;
  if (kind === "task" && id) body = <TaskDetailDrawer id={id} />;
  if (kind === "approval" && id) body = <ApprovalDetailDrawer id={id} />;
  if (kind === "service" && id) body = <ServiceDetailDrawer id={id} />;
  if (kind === "note" && id) body = <NoteDetailDrawer id={id} />;

  return (
    <aside
      className="aero-glass drawer-enter mx-3 my-3 ml-0 flex shrink-0 flex-col overflow-y-auto"
      style={{ width: 380, borderRadius: 24 }}
    >
      <div
        className="flex items-center justify-between px-4"
        style={{
          height: 44,
          borderBottom: "1px solid rgba(255,31,165,0.15)",
        }}
      >
        <span
          className="font-eyebrow"
          style={{
            fontSize: 10,
            fontWeight: 800,
            letterSpacing: "0.22em",
            textTransform: "uppercase",
            color: "var(--hot-pink)",
          }}
        >
          ✦ Detail
        </span>
        <button
          type="button"
          onClick={closeDrawer}
          className="glossy-pill glossy-pill--ghost glossy-pill--small"
          aria-label="Close drawer"
        >
          esc · close
        </button>
      </div>
      {body}
    </aside>
  );
}
